<!--
 * @Author: zhonghao
 * @Date: 2023-02-28 22:12:20
-->
<template>
  <div class="loading-box">
    <div class="load-block" v-if="isSaveUrl">
      <van-loading type="spinner" size="24" color="#999" />
      <span class="text">{{ txt }}</span>
      <div class="btn" @click="handleToLogin" v-if="showBtn">重新登录</div>
    </div>
  </div>
</template>

<script>
import { INDEX_PATH } from '../../store/mutation-types'
import { getIsJinxiuAuthNew } from '../../api/api'
import store from '@/store/index'
import router from '@/router/index'
import { generateRouter, beforeLoginFun, redirectToWxAuth, saveCasesharingReturnFromBackurl, cacheCasesharingRedirectFromAuth } from '@/utils/util'
import { roleDetails } from '@/api/zone'
import { getTrainIsSign } from '@/api/training'

export default {
  name: 'loginPage',
  data() {
    return {
      txt: '登录中...',
      showBtn: false,
      isSaveUrl: true
    }
  },
  created() {
    this.getIepLoginId()
    // var ua = navigator.userAgent.toLowerCase()
    // this.isSaveUrl = /iphone|ipad|ipod/.test(ua) ? sessionStorage.getItem('isSaveUrl') : true
    // if (this.isSaveUrl) {
    //   this.getIepLoginId()
    // } else {
    //   sessionStorage.setItem('isSaveUrl', true)
    //   window.location.reload()
    // }
  },
  computed: {
    userInfo() {
      return this.$store.getters.userInfo
    }
  },
  methods: {
    getQueryParams(url) {
      var queryParams = {}
      var parser = document.createElement('a')
      parser.href = url
      var queryStr = parser.search.substring(1)
      var params = queryStr.split('&')
      for (var i = 0; i < params.length; i++) {
        var param = params[i].split('=')
        queryParams[param[0]] = decodeURIComponent(param[1])
      }
      return queryParams
    },
    // 中转登录页，获取登录id
    async getIepLoginId () {
      sessionStorage.removeItem('gradeRolesList')
      sessionStorage.removeItem('userRole')
      sessionStorage.removeItem('gradeUserPermissions')
      let iepLoginId = this.$utils.getUrlParms('iepLoginId')
      // let newAgrt = this.$utils.getUrlParms('new_agrt')
      // if (Number(newAgrt) === 1) {
      //   window.location.href = `${process.env.iepUrl}/mobile/home?new_agrt=1`
      // } else
      if (!iepLoginId) {
        const csAuth = this.$utils.getUrlParms('csAuth')
        // 病例社区先落到本页：写入 localStorage 后再去 outMember，不走 iEP 自己的 /home 授权
        cacheCasesharingRedirectFromAuth()
        if (csAuth) {
          window.location.href = csAuth
          return
        }
        // 前端直接跳转微信授权
        redirectToWxAuth()
      } else {
        await this.$store.dispatch('delStorage')
        getIsJinxiuAuthNew({
          iepLoginId: iepLoginId
        }).then(res => {
          if (!res.data) {
            // 前端直接跳转微信授权
            redirectToWxAuth()
            return
          }
          // let iepLoginResult = JSON.parse(sessionStorage.getItem('iepLoginResult'))
          // if (!iepLoginResult) {
          let iepLoginResult = res.data
          // }
          sessionStorage.setItem('iepLoginResult', JSON.stringify(iepLoginResult))
          if (iepLoginResult.isLogin === 0) {
            // 90 天验证前先从 backurl 摘 csReturn（病例社区原页），验证页 URL 上已没有该信息
            saveCasesharingReturnFromBackurl(iepLoginResult)
            this.$store.dispatch('Login', iepLoginId).then(resp => {
              if (resp.data.accessToken) {
                store.dispatch('GetPermissionList').then(() => {
                  beforeLoginFun()
                })
              } else {
                beforeLoginFun()
              }
            }).catch(() => {
              beforeLoginFun()
            })
            return
          } else if (`${iepLoginResult.urlType}` === '2' && iepLoginResult.backurl) {
            window.location.href = atob(iepLoginResult.backurl)
            return false
          }
          this.$store.dispatch('Login', iepLoginId).then(resp => {
            if (store.getters.permissionList.length === 0 && resp.data.accessToken) {
              store.dispatch('GetPermissionList').then(res => {
                const menuData = res
                if (menuData === null || menuData === '' || menuData === undefined) return
                let constPermiss = generateRouter(menuData)
                // 添加主界面路由
                store.dispatch('UpdateAppRouter', constPermiss).then(() => {
                  // 根据roles权限生成可访问的路由表
                  // 动态添加可访问路由表
                  store.getters.addRouters.forEach(Router => {
                    router.addRoute(Router)
                  })
                })
                setTimeout(() => {
                  if (!beforeLoginFun()) return
                  if (window && window.localStorage.getItem('redirectURL')) {
                    let hrefTxt = window.localStorage.getItem('redirectURL').indexOf('/journeymob') > -1
                      ? window.localStorage.getItem('redirectURL').substring(11, 100000)
                      : window.localStorage.getItem('redirectURL')
                    window.localStorage.removeItem('redirectURL')
                    // window.location.href = hrefTxt
                    let areaId = this.getQueryParams(hrefTxt).areaId
                    let campId = this.getQueryParams(hrefTxt).campId
                    if (areaId) {
                      roleDetails({
                        areaId: areaId,
                        userId: this.userInfo.id
                      }).then(res => {
                        sessionStorage.setItem('roleResult', JSON.stringify(res.data))
                        if (`${this.userInfo.memberType}` === '0' && `${res.data.studentSign}` === '0' && `${res.data.tutorSign}` === '0' && `${res.data.peSign}` === '0') {
                          this.$router.push({
                            path: '/RTCZone/sign',
                            query: {
                              areaId: res.data.areaId
                            }
                          })
                        } else {
                          this.$router.push({ path: hrefTxt })
                        }
                      })
                      return
                    } else if (campId) {
                      getTrainIsSign({
                        campId: campId,
                        userId: this.userInfo.id
                      }).then(res => {
                        if (!res.data) {
                          this.$router.push({
                            path: '/trainingDetail',
                            query: {
                              campId
                            }
                          })
                        } else {
                          this.$router.push({ path: hrefTxt })
                        }
                      })
                      return
                    }
                    if (hrefTxt.indexOf('/register') > -1 || hrefTxt.indexOf('/sso/tempPage') > -1 || hrefTxt.indexOf('/loginPage') > -1) {
                      this.$router.push(INDEX_PATH)
                    } else {
                      sessionStorage.removeItem('isGradeCheck')
                      this.$router.push({ path: hrefTxt })
                    }
                    return
                  }
                  this.$router.push(INDEX_PATH)
                }, 1000)
              }).catch(err => {
                console.log('error', err)
              })
            }
          }).catch(err => {
            if (err.code === 111) {
              this.txt = '登录信息已过期'
              this.showBtn = true
            }
          }).catch()
        })
      }
    },
    handleToLogin() {
      // 前端直接跳转微信授权
      redirectToWxAuth()
    }
  }
}
</script>

<style scoped lang="less">
.loading-box {
  width: 100%;
  height: 100%;
  background: #f7f9fb;

  .load-block {
    width: 100%;
    position: absolute;
    top: 40%;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .text {
    margin-top: 5px;
    color: #999;
    font-size: 16px;
  }

  .btn {
    padding: 5px 10px;
    margin-top: 15px;
    color: #fff;
    background-color: #ff644a;
    border-radius: 4px;
    font-size: 14px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/loginPage/loginPage.vue